module.exports = __webpack_public_path__ + "img/Honig-aus-2021-560.bf8f0dde.jpg";